import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { notification, nestedModal, modal, alert } from 'redux/modules/app'

function decorator() {
  return ComposedComponent => {
    @connect(
      state => ({
        alertObj: state.app.alert,
        modalObj: state.app.modal,
        modalData: state.app.modal.data
      }),
      {
        notification,
        nestedModal,
        modal,
        alert,
        push
      }
    )
    class Trigger extends Component {
      static propTypes = {
        nestedModal: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        alert: PropTypes.func.isRequired
      }

      handleClose = () => {
        this.props.modal(null, null, null)
      }

      handleCloseAlert = () => this.props.alert(null, null)
      handleCloseNested = () => this.props.nestedModal(null)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onCloseNested={this.handleCloseNested}
            onCloseAlert={this.handleCloseAlert}
            onOpenAlert={this.props.alert}
            onClose={this.handleClose}
            onOpen={this.props.modal}
            modal={undefined}
          />
        )
      }
    }
    return Trigger
  }
}

export default decorator
